module ViewTypes

open Shared
open System
open Elmish
open Fable.Remoting.Client
//type State =
//    {
//      ShowSideBar : bool
//      Songs: ShortSong list
//      Lijsten: Lijst list
//      Lijst: ListPage.State
//      Song: SongPage.State
//    }

//type Msg =
//    | DefDoNothing
//    | DefGotSong of Song
//    | DefGotData of Data
//    | DefLijstenUpdated of Lijst list
//    | DefSongsUpdated of ShortSong list

//    | HamBurgerClicked
////    | NieuwSongClicked of Song
//    | NieuwLijstClicked of Lijst
//    | LijstClicked of Guid
//    | ListMsg of ListPage.Msg
//    | SongMsg of SongPage.Msg


type SongState =
    { SelectedSong: Song option
      WijzigSong: bool
      Fullscreen: bool }
type SongMsg =
    | WijzigSongClicked
    | BewaarSongClicked
    | CancelSongClicked
    | RemoveSongClicked
    | UpClicked
    | FwdClicked of Guid
    | BwdClicked of Guid
    | BPMClicked of Guid
    | FullScreenClicked

    | SongNameChanged of string
    | BPMChanged of string
    | LyricsChanged of string
    | SpotifyChanged of string
    | ArtistChanged of string
let SongInit () : SongState=
    { SelectedSong = None
      WijzigSong = false
      Fullscreen = false }



type LijstState =
    { SelectedLijst: Lijst option
      WijzigLijst: bool
      Filter: bool
      Filterstr: string
      AllSongs: ShortSong list
      LijstSongs: ShortSong list }
type LijstMsg =
    | LijstNameChanged of string
    | WijzigLijstClicked
    | LijstClicked of Lijst option
    | BewaarLijstClicked
    | RemoveLijstClicked
    | PositionUp of Guid
    | PositionDown of Guid
    | NewSongClicked of Song
    | FilterSongsChanged of string
    | FilterSongsTrash
    | UpdateAllSongs of ShortSong list
    | SongClicked of Guid
    | AddSongToLijstClicked of Guid
    | RemoveSongFromLijstClicked of Guid
    | CancelLijstEditClicked
let LijstInit (songs: ShortSong list) =
    { SelectedLijst = None
      WijzigLijst = false
      Filter = false
      Filterstr = ""
      AllSongs = songs
      LijstSongs = List.empty }


type AgendaEditItem =
    | Nothing
    | Date
    | Note
type AgendaState = {
    EditItem : Guid option
    EditDateOrNote : AgendaEditItem // true is date, false is note
    StringBuffer : string
    AgendaItems : AgendaItem list
    }
type AgendaMsg =
    | EditAgendaClicked of (Guid*AgendaEditItem)
    | DeleteAgendaClicked of AgendaItem
    | AddAgendaClicked of AgendaItem
    | UpdateAgendaDate
    | UpdateAgendaNote of AgendaItem
    | AgendaDateChanged of string
    | AgendaNoteChanged of string

let AgendaInit (dates: AgendaItem list) =
    {
        EditItem = None
        EditDateOrNote = AgendaEditItem.Nothing
        StringBuffer =""
        AgendaItems = dates
    }


type ViewStatus =
    |ShowAll 
    |ShowSong
    |ShowLijst
    |ShowAgenda

type State =
    {
      ViewStatus: ViewStatus
      ShowSideBar : bool
      Songs: ShortSong list
      Lijsten: Lijst list
      Lijst: LijstState
      Song: SongState
      Agenda: AgendaState
    }

type Msg =
    | DefDoNothing
    | DefGotSong of Song
    | DefGotData of Data
    | DefLijstenUpdated of Lijst list
    | DefSongsUpdated of ShortSong list
    | DefAgendaUpdated of AgendaItem list
    | DefAgendaUpdatedWithNewItem of AgendaItem list

    | LogoClicked
    | HamBurgerClicked
//    | NieuwSongClicked of Song
    | NieuwLijstClicked of Lijst
    | LijstClicked of Guid
    | ListMsg of LijstMsg
    | SongMsg of SongMsg
    | AgendaMsg of AgendaMsg


let init () : State * Cmd<Msg> =
    let state =
        {
          ViewStatus = ViewStatus.ShowAll 
          ShowSideBar = true
          Songs = []
          Lijsten = []
          Lijst = LijstInit List.empty
          Song = SongInit ()
          Agenda = AgendaInit List.empty
        }
    state, Cmd.OfAsync.perform API.bandAidApi.getData () DefGotData